<app-spinner [(show)]="loading"></app-spinner>
<main class="esf-main-content -has-transition -width-max" *ngIf="!loading">
  <div class="esf-container main-content--fit-screen">

    <h1 class="esf-heading esf-heading--page esf-action-heading">
      <span i18n='Main heading for the attributes page@@clubComponent.heading.attributes' class="esf-action-heading__text">Attributes</span>
      <span class="esf-action-heading__actions">
        <span class="esf-action-heading__action">
          <button class="esf-button esf-button--filled esf-button--icon esf-button--icon-small"
                  (click)="openCreateAttribute()"
                  [edsTooltip]="tooltipTranslations.i18nAddNewAttribute">
            <svg class="esf-icon" width="16" height="16">
              <use xlink:href="#esf-icon-plus"></use>
            </svg>
          </button>
        </span>
      </span>
    </h1>

    <app-paginated-table [columns]="columns"
                         [keys]="keys"
                         [data]="data"

                         [baseApi]="baseApi"
                         [customQueries]="customQueries"
                         (dataFetchedEmitter)="setClubAttributes($event)"
                         [actionButtons]="actionButtons"

                         (rowButtonClickEvent)="actionButtonClicked($event)"
                         (rowClickEvent)="openEditAttribute($event)"

                         [emptyStateText]="i18nEmptyState"
                         [emptyStateIcon]="'#esf-icon-attributes'">
    </app-paginated-table>

  </div>
</main>

<app-club-attributes-form [selectedClub]="selectedClub"
                          (setSubmitLoading)="setSubmitLoading($event)"
                          *ngIf="attributeService.createAttributeModal || attributeService.editAttributeModal">
</app-club-attributes-form>
